<template>
    <div class="d-flex justify-content-center align-items-center flex-column h-100 w-100">
        <div class="row mx-0 justify-content-center w-100">
            <div class="col-12 col-md-8 col-xl-6">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="text-center">
                            <small class="text-bold">{{overline}}</small>
                            <h4 >{{title}}</h4>
                            <div class="transition-image w-100">
                                <b-img :src="image" alt="..." fluid v-if="image"/>
                            </div>
                            <p class="mt-3">{{description}}</p>
                        </div>
                    </div>
                    <div class="col-12">
                        <slot/>
                    </div>
                    <div class="col-12">
                        <div class="d-flex justify-content-end align-items-center mt-4">
                            <b-button
                                v-if="secondaryButton"
                                variant="light"
                                class="no-wrap mt-2"
                                @click="$emit('onSecondary')">
                                {{secondaryButton.text}}</b-button>
                            <b-button
                                v-if="primaryButton"
                                variant="secondary"
                                class="no-wrap ml-2 mt-2"
                                @click="$emit('onPrimary')">
                                {{primaryButton.text}}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TransitionBlock",
    props:{
        overline: String,
        title: String,
        description: String,
        image: String,
        primaryButton: Object,
        secondaryButton: Object
    }
}
</script>

<style scoped lang="scss">
    .transition-image{
        width: 200px;
    }
</style>